import HostedMobileLayout from '../../../layouts/MobileLayout';
import HostedDoneScreen from '../shared/DoneScreen';
import { type DonePageProps } from '../../../chulak/ChulakSession';

export default function HostedMobileDonePage({
  onComplete,
  continueInApp,
}: DonePageProps) {
  return (
    <HostedMobileLayout>
      <HostedDoneScreen onComplete={onComplete} continueInApp={continueInApp} />
    </HostedMobileLayout>
  );
}
